import { trackEvent, TrackingType } from 'tracking/events'

const getSchema = () => 'reg_page_tracking'

export enum LoginAction {
  CLICK = 'Click',
  CHANGE = 'Change',
  BLUR_EVENT = 'Focus OUT',
}

export enum FormName {
  HOMEPAGE = 'direct_homepage',
  LOGIN_MODAL = 'homepage_login_modal',
}

interface EventData {
  fieldName?: string
  fieldValue?: string
}

interface LoginOptions {
  action: LoginAction
  formName: FormName
  trackingType?: TrackingType
  eventData?: Record<keyof EventData, any>
}

export const trackAction = ({
  trackingType = TrackingType.BATCHED,
  action,
  eventData,
  formName,
}: LoginOptions) =>
  trackEvent({
    type: trackingType,
    schema: getSchema(),
    payload: {
      event_name: action,
      form_name: formName,
      field_name: eventData.fieldName,
      field_value: eventData.fieldValue,
    },
  })

// On Link Click
export const trackLinkClick = (eventData: EventData) =>
  trackAction({
    action: LoginAction.CLICK,
    eventData: {
      fieldValue: eventData.fieldValue,
      fieldName: 'Link',
    },
    formName: FormName.HOMEPAGE,
  })

// On Button Click
export const trackButtonClick = (eventData: EventData) =>
  trackAction({
    action: LoginAction.CLICK,
    eventData: {
      fieldValue: eventData.fieldValue,
      fieldName: 'Button',
    },
    formName: FormName.LOGIN_MODAL,
  })

// On Change CheckBox
export const trackOnChangeCheckbox = (fieldValue: string) =>
  trackAction({
    action: LoginAction.CHANGE,
    eventData: {
      fieldValue: fieldValue,
      fieldName: 'stay_logged_in_checked',
    },
    formName: FormName.LOGIN_MODAL,
  })

// On Blur
export const trackOnBlur = (eventData: EventData) =>
  trackAction({
    action: LoginAction.BLUR_EVENT,
    eventData: {
      fieldValue: eventData.fieldValue,
      fieldName: eventData.fieldName,
    },
    formName: FormName.LOGIN_MODAL,
  })
